import axios from 'axios';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const LOADING_DASHBOARD_INFO = () => ({ type: 'LOADING_DASHBOARD_INFO', });
export const LOADING_DASHBOARD_INFO_SUCCESS = () => ({ type: 'LOADING_DASHBOARD_INFO_SUCCESS', });
export const LOADING_DASHBOARD_INFO_ERROR = () => ({ type: 'LOADING_DASHBOARD_INFO_ERROR', });

export const getDashboardInfo = (dispatch) => {
  dispatch({ type: LOADING_DASHBOARD_INFO });

  axios
    .get(`${serverURI}/api/dashboard/info`)
    .then((res) => {
      dispatch({
        type: LOADING_DASHBOARD_INFO_SUCCESS,
        payload: res.data.dashboardInfo
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_DASHBOARD_INFO_ERROR, payload: err });
      errorHandler(err);
    });
};
